import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import CourseProp from './propTypes/courseProp';
import Title from '../../commonComponents/Title';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import translate from '../../commonComponents/translate';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import Academy from './Academy';
import StripeCardProp from '../profile/propTypes/StripeCardProp';
import CategoryProp from './propTypes/categoryProp';
import TopicBanner from '../../commonComponents/pageLayout/header/TopicBanner';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import CurrencyProp from '../profile/propTypes/currencyProp';
import HardSkillProp from '../challenges/propTypes/hardSkillProp';
import CourseTagProp from '../../commonComponents/propTypes/CourseTagProp';
import PriceRangeProp from './propTypes/PriceRangeProp';
import MetaContext from '../../contextProviders/MetaContext';

function AcademyWrapper(props) {
  const {
    t,
    cards,
    enrolledCourses,
    categories,
    languages,
    currencies,
    skills,
    tags,
    applyFilters,
    priceRange,
  } = props;
  const { userPortalMenus } = useContext(MetaContext);
  const title =
    userPortalMenus.find(u => u.type === 'academy')?.name ||
    t('academy_head_title');
  const hasWhiteBar = true;
  const filter = 'courses';
  return (
    <Title title={t('academy.whiteBar.courses')}>
      <ContentContainer>
        <SubHeader title={title} hasWhiteBar={hasWhiteBar} filter={filter} />
        <TopicBanner />
        <div className="m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              <Academy
                enrolledCourses={enrolledCourses}
                cards={cards}
                categories={categories}
                languages={languages}
                currencies={currencies}
                skills={skills}
                tags={tags}
                applyFilters={applyFilters}
                priceRange={priceRange}
              />
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

AcademyWrapper.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  enrolledCourses: PropTypes.arrayOf(PropTypes.shape(CourseProp.propType)),
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)),
  categories: PropTypes.arrayOf(PropTypes.shape(CategoryProp.propType))
    .isRequired,
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  skills: PropTypes.arrayOf(PropTypes.shape(HardSkillProp.propType)).isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape(CourseTagProp.propType)),
  applyFilters: PropTypes.bool,
  priceRange: PropTypes.shape(PriceRangeProp.propType).isRequired,
};

AcademyWrapper.defaultProps = {
  enrolledCourses: null,
  cards: null,
  tags: [],
  applyFilters: false,
};

export default translate(AcademyWrapper);
